export default __webpack_public_path__ + "static/design-step-by-step-schedule-493f8ea04c4fd4216e547cae50937b8b.png";